import WidgetGroups from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StoreRetailModeToggle from "@store/Components/Store/StoreRetailModeToggle";
import * as React from "react";

interface Props extends WidgetProps {}

const RetailModeToggleWidget: React.FunctionComponent<Props> = (props: Props) => {
    return <StoreRetailModeToggle />;
};

const widgetModule: WidgetModule = {
    component: RetailModeToggleWidget,
    definition: {
        group: "Common",
        displayName: "Retail Mode Setting Toggle",
        icon: "heading",
        fieldDefinitions: [],
    },
};

export default widgetModule;
